module.exports = __webpack_public_path__ + "img/franchising_help_training2.c1d6ba45.png";